module.exports = __webpack_public_path__ + "img/prepare-exam-guide-2.727da47b.jpg";